<template>
  <el-dialog
    v-dialogDrag
    class="mini-dialog"
    :append-to-body="true"
    :visible.sync="visible"
    :close-on-click-modal="false"
    title="验收意见"
  >
    <el-form :model="form" ref="form" label-width="0px">
      <el-form-item label="" prop="reason">
        <el-input
          class="el-input !w-full"
          placeholder="请输入验收意见"
          maxlength="50"
          show-word-limit
          type="textarea"
          rows="3"
          v-model="form.reason"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SourcesDangerRiskGradeControlApi } from '@wiz-api/double-prevention-management'

const sourcesDangerRiskGradeControlApi = new SourcesDangerRiskGradeControlApi()
export default {
  name: 'accept-form',
  props: {
    taskId: {
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  data() {
    return {
      visible: true,
      form: {},
    }
  },
  computed: {},
  methods: {
    async save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.$emit('handleOk', this.form.reason)
        }
      })
    },
  },
  created() {},
}
</script>

<style scoped lang="scss"></style>
